import { spawn } from 'redux-saga/effects';

import { sagas as createTokenSagas } from './createTokenModule';
import { sagas as bindAgreementSagas } from './bindAgreementModule';

export default function* sagas() {
	yield spawn(createTokenSagas);
	yield spawn(bindAgreementSagas);
}
